declare global {
    interface Window {
      dataLayer?: any[];
    }
  }
export function gtmCustomEventLeadFlow(leadObj:any){
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(leadObj);
    }
}